import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../../styles/PCResponsive.css';
import { resetPassword } from '../../../api';

// Ensure no transform overrides for PC version
const resetTransformStyles = {
  transform: 'none !important',
  rotate: 'none !important',
  skew: 'none !important',
  transformOrigin: 'center center !important'
};

function PasswordResetPC() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get userId from navigation state or URL params, with fallback
  const getUserIdFromState = () => {
    return location.state?.userId || 
           new URLSearchParams(location.search).get('userId') || 
           'Test';
  };

  const [formData, setFormData] = useState({
    userId: getUserIdFromState(),
    newPassword: '',
    confirmPassword: ''
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear errors when user types
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
    setError(''); // Clear general error
  };

  const validateForm = () => {
    const newErrors = {};

    if (formData.newPassword !== formData.confirmPassword) {
      newErrors.confirmPassword = '비밀번호가 일치하지 않습니다';
    }

    if (formData.newPassword.length < 6) {
      newErrors.newPassword = '비밀번호는 6자 이상이어야 합니다';
    }

    if (formData.newPassword.length > 10) {
      newErrors.newPassword = '비밀번호는 10자 이하여야 합니다';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      await resetPassword(formData.userId, formData.newPassword, formData.confirmPassword);
      alert("비밀번호가 성공적으로 변경되었습니다!");
      navigate('/login');
    } catch (err) {
      // Handle 404 status code specifically
      if (err.response?.status === 404) {
        alert("존재하지 않습니다");
        setError(""); // Remove any existing error message
      } else {
        setError(err.response?.data?.message || "비밀번호 변경에 실패했습니다.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pc-page-container" style={resetTransformStyles}>
      <div className="pc-content-wrapper" style={resetTransformStyles}>
        
        
        {/* Main Content */}
        <main style={{
          ...resetTransformStyles,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '60px 20px',
          minHeight: 'calc(100vh - 200px)',
          width: '100%',
          backgroundColor: '#ffffff',
          position: 'relative',
          overflow: 'hidden',
        }}>
          <div style={{
            width: '100%',
            maxWidth: '454px',
            margin: '0 auto',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative',
            zIndex: 1
          }}>
            {/* Title */}
            <h1 style={{
              fontFamily: 'NotoSansCJKkr, sans-serif',
              fontSize: '38px',
              fontWeight: '500',
              color: '#222',
              margin: '0 0 22px 0',
              textAlign: 'center',
              lineHeight: '0.82',
              letterSpacing: '-0.95px',
              position: 'relative',
              zIndex: 2
            }}>
              비밀번호 재설정
            </h1>

            {/* Instructions */}
            <div style={{
              marginBottom: '80px',
              textAlign: 'center'
            }}>
              <p style={{
                fontFamily: 'NotoSansCJKkr, sans-serif',
                fontSize: '19px',
                fontWeight: 'normal',
                color: '#222',
                lineHeight: '1.5',
                letterSpacing: '-0.48px',
                margin: '0',
                textAlign: 'center'
              }}>
                임시 비밀번호로 로그인 하셨습니다. 보안을 위하여 비밀번호를 새로 설정해 주세요.
              </p>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} style={{ 
              width: '100%',
              position: 'relative',
              zIndex: 2
            }}>
              {/* ID Field */}
              <div style={{
                width: '454px',
                height: '61px',
                marginBottom: '20px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingBottom: '10px',
                borderBottom: '1px solid #e0e0e0'
              }}>
                <span style={{
                  fontFamily: 'NotoSansCJKkr, sans-serif',
                  fontSize: '22px',
                  fontWeight: '500',
                  color: '#222',
                  lineHeight: '1.61',
                  letterSpacing: '-0.55px',
                  textAlign: 'left'
                }}>
                  아이디
                </span>
                <span style={{
                  fontFamily: 'NotoSansCJKkr, sans-serif',
                  fontSize: '22px',
                  fontWeight: '500',
                  color: '#1eafa1',
                  lineHeight: '1.61',
                  letterSpacing: '-0.55px',
                  textAlign: 'right'
                }}>
                  {formData.userId}
                </span>
              </div>

              {/* New Password Field */}
              <div style={{
                marginBottom: '10px'
              }}>
                <input
                  type="password"
                  name="newPassword"
                  value={formData.newPassword}
                  onChange={handleChange}
                  placeholder="신규 비밀번호"
                  required
                  disabled={loading}
                  style={{
                    width: '454px',
                    height: '61px',
                    padding: '19px 20px',
                    border: 'solid 1px #ddd',
                    borderRadius: '4px',
                    fontSize: '22px',
                    fontFamily: 'NotoSansCJKkr, Arial, sans-serif',
                    fontWeight: '500',
                    color: '#222',
                    transition: 'border-color 0.3s ease',
                    boxSizing: 'border-box',
                    backgroundColor: '#fff'
                  }}
                />
                {errors.newPassword && (
                  <div style={{
                    color: '#f44336',
                    fontSize: '14px',
                    marginTop: '5px',
                    textAlign: 'left'
                  }}>
                    {errors.newPassword}
                  </div>
                )}
              </div>

              {/* Confirm Password Field */}
              <div style={{
                marginBottom: '20px'
              }}>
                <input
                  type="password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  placeholder="비밀번호 확인"
                  required
                  disabled={loading}
                  style={{
                    width: '454px',
                    height: '61px',
                    padding: '19px 20px',
                    border: 'solid 1px #ddd',
                    borderRadius: '4px',
                    fontSize: '22px',
                    fontFamily: 'NotoSansCJKkr, Arial, sans-serif',
                    fontWeight: '500',
                    color: '#222',
                    transition: 'border-color 0.3s ease',
                    boxSizing: 'border-box',
                    backgroundColor: '#fff'
                  }}
                />
                {errors.confirmPassword && (
                  <div style={{
                    color: '#f44336',
                    fontSize: '14px',
                    marginTop: '5px',
                    textAlign: 'left'
                  }}>
                    {errors.confirmPassword}
                  </div>
                )}
              </div>

              {/* Error Message */}
              {error && (
                <div style={{
                  color: '#f44336',
                  fontSize: '14px',
                  marginBottom: '15px',
                  textAlign: 'center'
                }}>
                  {error}
                </div>
              )}

              {/* Confirm Button */}
              <div style={{
                textAlign: 'center',
                marginTop: '11px'
              }}>
                <button 
                  type="submit" 
                  disabled={loading}
                  style={{
                    width: '454px',
                    height: '61px',
                    padding: '0',
                    backgroundColor: '#16a88b',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '4px',
                    fontSize: '22px',
                    fontFamily: 'NotoSansCJKkr, Arial, sans-serif',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease',
                    boxSizing: 'border-box',
                    lineHeight: '61px',
                    letterSpacing: '-0.55px',
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {loading ? "변경 중..." : "확인"}
                </button>
              </div>
            </form>
          </div>
        </main>

        
      </div>
    </div>
  );
}

export default PasswordResetPC; 